import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, DecimalPipe } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { DateTimeModule } from './shared/date-time/date-time.module';
import { UploadsComponent } from './uploads/uploads.component';
import { ExcelArticlesImportComponent } from './uploads/excel-import/excel-articles-import.component';
import { DxfImportComponent } from './uploads/dxf-import/dxf-import.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { ToastsContainer } from './shared/toast-service/toast.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ExcelVarietyImportsComponent } from './uploads/excel-variety-imports/excel-variety-imports.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbdSortableHeader } from './articles/services/sortable.directive';
import { ModelViewerComponent } from './model-viewer/model-viewer.component';
import { ArticlesComponent } from './articles/articles.component';
import { UploadService } from './uploads/services/upload.service';
import { ShapeService } from './model-viewer/shape.service';
import { AppToastService } from './shared/toast-service/toast-service';
import { ArticleService } from './articles/services/article.service';
import { LoginComponent } from './login/login.component';
import { JsUploadComponent } from './model-viewer/js-upload/js-upload.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DxfToJpgComponent } from './dxf-to-jpg/dxf-to-jpg.component';
import { CustomDxfViewer } from './shared/dxf/custom-dxf-viewer';
import { DxfViewerComponent } from './dxf-viewer/dxf-viewer.component';
import { ArticleComponent } from "@schuco-vcl/usc-lib";
import { ArticleViewerComponent } from "./article-viewer/article-viewer.component";
import { NzTooltipDirective } from "ng-zorro-antd/tooltip";
import { NzContentComponent, NzHeaderComponent, NzLayoutComponent } from "ng-zorro-antd/layout";
import { NzListModule } from "ng-zorro-antd/list";
import { ApiModule } from './api/api.module';
import { SystemsComponent } from './systems/systems.component';
import { ArticlesManagementComponent } from './articles-management/articles-management.component';
import { RulesDashboardComponent } from './rules-dashboard/rules-dashboard.component';
import { RulesManagementComponent } from './rules-management/rules-management.component';
import { MatingRuleEditComponent } from './rules-management/mating-rule-edit/mating-rule-edit.component';
import { DataTableComponent } from './shared/components/data-table/data-table.component';
import { RuleFormComponent } from './shared/components/rule-form/rule-form.component';
import { LandingComponent } from './landing/landing.component';
import { JointRulesEditComponent } from './rules-management/joint-rule-edit/joint-rules-edit.component';
import { DecisionTreeComponent } from './decision-tree/decision-tree.component';
import { BaseChartDirective } from 'ng2-charts';
import { NgDiagramComponent, initializeModel, provideNgDiagram, NgDiagramBackgroundComponent } from 'ng-diagram';


@NgModule({
  declarations: [
    AppComponent,
    UploadsComponent,
    ExcelArticlesImportComponent,
    DxfImportComponent,
    ExcelVarietyImportsComponent,
    ModelViewerComponent,
    ArticlesComponent,
    LoginComponent,
    JsUploadComponent,
    DxfToJpgComponent,
    DxfViewerComponent,
    ArticleViewerComponent,
    SystemsComponent,
    ArticlesManagementComponent,
    RulesDashboardComponent,
    RulesManagementComponent,
    MatingRuleEditComponent,
    DataTableComponent,
    RuleFormComponent,
    LandingComponent,
    JointRulesEditComponent,
    DecisionTreeComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    AppRoutingModule,
    RouterModule,
    DateTimeModule,
    NgbModule,
    NgxSpinnerModule,
    ToastsContainer,
    ReactiveFormsModule,
    FormsModule,
    NgbdSortableHeader,
    PdfViewerModule,
    NgbDropdownModule,
    NzTooltipDirective,
    NzLayoutComponent,
    NzHeaderComponent,
    NzContentComponent,
    ArticleComponent,
    ApiModule,
    BaseChartDirective,
    NgDiagramComponent,
    NgDiagramBackgroundComponent
], 
  providers: [
      UploadService,
      ShapeService,
      AppToastService,
      ArticleService,
      DecimalPipe,
      CustomDxfViewer,
      NgbDropdownModule,
      NzListModule,
      provideHttpClient(withInterceptorsFromDi()),
      ArticleComponent,
      provideNgDiagram()
    ],
})
export class AppModule {
}
